import React from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { TextField, Button, Modal, CustomSelect } from 'src/components';
import { BsCheckCircleFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { fetchItemCategories } from 'src/redux/action/item.action';
import useFetch from 'src/hooks/useFetch';
import Radio from 'src/components/radio';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'src/components/select';
import { FieldProps } from 'formik';
import { DefaultSelect } from 'src/components/defaultSelect';
import DiscountCustomSelect from 'src/components/DiscountSelect/DiscountCustomSelect';
import { fetchDiscount } from 'src/redux/action/discount.action';
import { AiOutlineCalendar } from 'react-icons/ai';
import Datepicker from 'src/components/datepicker';
import { BiErrorCircle } from 'react-icons/bi';
import SlideInModal from 'src/components/slideInModal';

interface IProps {
  handleModal: () => void;
  showModal: boolean;
  fetchData: () => void;
  setEditDiscount: (val: boolean) => void;
  setEditDiscountId: (val: string) => void;
  editDiscount: boolean;
  editDiscountId: string;
  editDiscountData: any;
}

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Discount Name must a at least 3 character long')
    .required('Discount Name is required'),
  assignTo: Yup.string().required('Required'),
  type: Yup.string().required('Type is required'),
  value: Yup.number().required('Value is required'),
  start_date: Yup.date().nullable(),
  end_date: Yup.date()
    .nullable()
    .min(Yup.ref('start_date'), 'End Date can not be before Start Date'),
});

const AddDiscount: React.FC<IProps> = ({
  showModal,
  handleModal,
  editDiscount,
  editDiscountId,
  setEditDiscount,
  setEditDiscountId,
  editDiscountData,
}) => {
  const { data: categoryData } = useFetch('/categories');
  const { data: itemsData } = useFetch('/items');
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const [selectedDiscountAssign, setSelectedDiscountAssign] =
    React.useState('');
  const dispatch = useDispatch();

  const intValues = {
    name: editDiscountData ? editDiscountData?.name : '',
    assignTo: editDiscount ? editDiscountData?.appliedTo : '',
    type: editDiscount ? editDiscountData?.type : '',
    value: editDiscount ? editDiscountData?.value : '',
    items: editDiscount
      ? editDiscountData?.items?.map((item: any) => item.id)
      : [],
    categories: editDiscount
      ? editDiscountData?.categories?.map((category: any) => category.id)
      : [],
    start_date: null,
    end_date: null,
  };
  const handleSubmit = async (val: any, { resetForm }: any) => {
    const payload = {
      assignTo: val.assignTo,
      id: editDiscountId,
      name: val?.name,
      value: val?.value,
      items: val?.assignTo == 'items' ? val?.items : [],
      categories: val?.assignTo == 'categories' ? val?.categories : [],
      type: val.type === 'percent' ? 'percent' : 'amount',
      start_date: val?.start_date,
      end_date: val?.end_date,
    };
    try {
      if (editDiscount) {
        await Service.put('/discounts/edit', payload);
      } else {
        await Service.post('/discounts/create', payload);
      }
      handleModal();
      dispatch(fetchDiscount() as any);
      toastAlert(
        'success',
        `${val?.name} discount is successfully ${
          editDiscount ? 'edited' : 'added'
        }`
      );
      resetForm();
      setErrorMsgPost('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
    }
  };

  const filterCategory = categoryData?.categories
    ? categoryData?.categories?.map((item: any) => {
        return {
          name: item?.categoryInfo?.name,
          id: item?.categoryInfo?.id,
        };
      })
    : [];

  const filterItem = itemsData?.items
    ? itemsData?.items?.map((item: any) => {
        return {
          name: item?.name,
          id: item?.id,
        };
      })
    : [];

  const assignDiscount: any = [
    { label: 'items', value: '1' },
    { label: 'categories', value: '2' },
  ];

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={editDiscount ? 'Edit discount' : ' Add Discount'}
          onClick={handleModal}
          className="bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, values, setFieldValue }) => (
                <Form className="mt-5">
                  <TextField
                    label="Name"
                    name="name"
                    defaultValue={
                      editDiscountData ? editDiscountData?.name : ''
                    }
                  />

                  <Field
                    name="assignTo"
                    options={assignDiscount}
                    // defaultValue={assignDiscount?.findIndex(
                    //   (item: any) =>
                    //     item.label ===
                    //     Object.keys(
                    //       (editDiscount && editDiscountData?.assignedTo) || {}
                    //     ).join(',')
                    // )}
                    defaultValue={assignDiscount?.findIndex(
                      (item: any) => item.label === editDiscountData?.appliedTo
                    )}
                    className="mt-3"
                    component={DefaultSelect}
                    isMulti={false}
                    label="Assign Discount To"
                    onChangeCallback={(newSelectOptions: any) => {
                      setSelectedDiscountAssign(newSelectOptions.label);
                      setFieldValue('assignTo', newSelectOptions.label);
                    }}
                    getSingleDiscount={editDiscountData}
                  />

                  {selectedDiscountAssign === 'items' ||
                  editDiscountData?.appliedTo == 'items' ? (
                    <div
                      className={`${
                        selectedDiscountAssign === 'categories' ? 'hidden' : ''
                      }`}
                    >
                      <Field
                        name="items"
                        options={filterItem}
                        className={'mt-3 mb-5'}
                        component={DiscountCustomSelect}
                        isMulti={true}
                        label="Items"
                        defaultValue={
                          editDiscountData?.items &&
                          editDiscountData?.items.map((item: any) => ({
                            label: item.name,
                            value: item.id,
                          }))
                        }
                      />
                    </div>
                  ) : null}

                  {selectedDiscountAssign === 'categories' ||
                  editDiscountData?.appliedTo == 'categories' ? (
                    <div
                      className={`${
                        selectedDiscountAssign === 'items' ? 'hidden' : ''
                      }`}
                    >
                      {' '}
                      <Field
                        name="categories"
                        options={filterCategory}
                        className={'mt-3 mb-5'}
                        component={DiscountCustomSelect}
                        isMulti={true}
                        label="Categories"
                        defaultValue={
                          editDiscountData?.categories &&
                          editDiscountData?.categories.map((item: any) => ({
                            label: item.name,
                            value: item.id,
                          }))
                        }
                      />
                    </div>
                  ) : null}

                  <div className="my-5">
                    <p className="text-sm mb-2">Type</p>
                    <Radio
                      labelOne="Percentage"
                      labelTwo="Amount"
                      valueOne="percent"
                      valueTwo="Amount"
                      name="type"
                      selectedValue={
                        editDiscountData && editDiscountData.type === 'amount'
                          ? 'Amount'
                          : editDiscountData &&
                            editDiscountData.type === 'percent'
                          ? 'percent'
                          : ''
                      }
                    />
                  </div>
                  <TextField
                    name="value"
                    label={'Value'}
                    type="text"
                    defaultValue={
                      editDiscount && editDiscountData
                        ? editDiscountData?.value
                        : ''
                    }
                  />

                  {/* <div className="flex">
                    <Datepicker
                      label={'Start Date'}
                      id={'start_date'}
                      name={'start_date'}
                    />
                    <Datepicker
                      label={'End Date'}
                      id={'end_date'}
                      name={'end_date'}
                    />
                  </div> */}
                  <div className="relative mt-10">
                    <BiErrorCircle
                      size={17}
                      color="#fff"
                      className="absolute top-2 mx-2"
                    />
                    <ErrorMessage
                      component="div"
                      name={'end_date'}
                      className="bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
                    />
                  </div>
                  {/* <div className=" w-full h-10 relative   bg-primary-15 rounded">
                      <label htmlFor="">End Date</label>
                      <DatePicker
                        className="w-full  mt-2 appearance-none text-text-black placeholder:capitalize rounded py-3 block placeholder:text-sm px-3 bg-pure-white text-sm ring-1 ring-light-grey focus-within:ring-1 focus-within:ring-primary focus-within:outline-0"
                        selected={endDate}
                        name="end_date"
                        id="end_date"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM-DD-YYYY"
                        showMonthDropdown
                        showYearDropdown
                        scrollableYearDropdown
                        onChange={(date: Date) => setEndDate(date)}
                      />
                    </div> */}
                  <div className="flex items-center justify-end mt-14">
                    <Button
                      text={editDiscount ? 'edit discount' : ' Add Discount'}
                      variant="primary"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                      type="submit"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddDiscount);
